import React from "react";

const loadGlobalPages = {
  listing: () => import("../../pages/property-listing/index.jsx"),
  DestinationListing: () => import("../../pages/destination-listing/index.jsx"),
  singleProperty: () =>
    import("../../pages/single-property-view/Single-property-view.jsx"),

  Signin: () => import("../../pages/auth/signin/index.jsx"),
  CreateAccount: () =>
    import("../../pages/auth/create-account/Create-account.jsx"),
  Signup: () => import("../../pages/auth/signup/index.jsx"),
  CreatePassword: () =>
    import("../../pages/auth/password/create-password/index.jsx"),
  ResetPassword: () =>
    import("../../pages/auth/password/reset-password/index.jsx"),
  MessageForm: () => import("../../pages/auth/action-confirmation/index.jsx"),

  AuthSuccess: () => import("../../pages/auth/success/index.jsx"),
  AuthFailure: () => import("../../pages/auth/failure/index.jsx"),

  PrivacyPolicy: () =>
    import("../../pages/link-related/privacy-policy/index.jsx"),
  TermsConditions: () =>
    import("../../pages/link-related/terms-conditions/index.jsx"),
  CookiePolicy: () =>
    import("../../pages/link-related/cookie-policy/index.jsx"),

  DSARForm: () => import("../../pages/link-related/dsar-form/index.jsx"),

  Disclaimer: () => import("../../pages/link-related/disclaimer/index.jsx"),
  AcceptableUsePolicy: () =>
    import("../../pages/link-related/acceptable-use-policy/index.jsx"),

  NotFound: () => import("../../pages/not-found/index.jsx"),

  GoogleMap: () =>
    import(
      "../../components/property-listing-cards/google-map/modal/index.jsx"
    ),
  MobilePaymentIntialization: () =>
    import("../../pages/mobile-payment-initialize/index.jsx"),
};

const glabalLazyPages = {
  listing: React.lazy(() => loadGlobalPages.listing()),
  DestinationListing: React.lazy(() => loadGlobalPages.DestinationListing()),
  singleProperty: React.lazy(() => loadGlobalPages.singleProperty()),
  Signin: React.lazy(() => loadGlobalPages.Signin()),
  CreateAccount: React.lazy(() => loadGlobalPages.CreateAccount()),
  Signup: React.lazy(() => loadGlobalPages.Signup()),
  CreatePassword: React.lazy(() => loadGlobalPages.CreatePassword()),
  MessageForm: React.lazy(() => loadGlobalPages.MessageForm()),
  ForgotPassword: React.lazy(() => loadGlobalPages.ForgotPassword()),

  ResetPassword: React.lazy(() => loadGlobalPages.ResetPassword()),

  AuthSuccess: React.lazy(() => loadGlobalPages.AuthSuccess()),
  AuthFailure: React.lazy(() => loadGlobalPages.AuthFailure()),

  PrivacyPolicy: React.lazy(() => loadGlobalPages.PrivacyPolicy()),
  TermsConditions: React.lazy(() => loadGlobalPages.TermsConditions()),
  CookiePolicy: React.lazy(() => loadGlobalPages.CookiePolicy()),
  Disclaimer: React.lazy(() => loadGlobalPages.Disclaimer()),
  AcceptableUsePolicy: React.lazy(() => loadGlobalPages.AcceptableUsePolicy()),
  DSARForm: React.lazy(() => loadGlobalPages.DSARForm()),

  NotFound: React.lazy(() => loadGlobalPages.NotFound()),
  GoogleMap: React.lazy(() => loadGlobalPages.GoogleMap()),
  MobilePaymentIntialization: React.lazy(() =>
    loadGlobalPages.MobilePaymentIntialization()
  ),
};

export { loadGlobalPages, glabalLazyPages };
